import { render } from "./CategorySegmentDescriptionTabView.vue?vue&type=template&id=08f21c6e"
import script from "./CategorySegmentDescriptionTabView.vue?vue&type=script&lang=js"
export * from "./CategorySegmentDescriptionTabView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__